import React, { useEffect, useState } from "react";
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { AdminLayout } from "../../layouts";
import { Box, Button, Chip, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControlLabel, Grid, IconButton, Menu, MenuItem, Modal, Paper, Select, TextField, Typography } from "@mui/material";
import Switch from '@mui/material/Switch';
import { DataGrid, GridToolbar, GridRowsProp, GridColDef, GridFilterModel, GridColumnVisibilityModel, GridCellParams } from '@mui/x-data-grid';
import { BorderColor, Delete, Edit, MoreVert, People, Preview, Visibility } from "@mui/icons-material";
import { deleteGrupo, getCursosAdmin, getGruposAdmin, postGrupo, putGrupo } from "../../api/providers";
import Cookies from "js-cookie";
import { LoadingScreen } from "../../ui/components/LoadingScreen";
import { useForm } from "react-hook-form";

export const GroupsPage = () => {
    const navigate = useNavigate();

    const RowMenu = (params: any) => {
        let paramsRow = params.rowIndex;

        const [anchorEl, setAnchorEl] = React.useState(null);
        const open = Boolean(anchorEl);

        const handleClick = (event: any) => {
            setAnchorEl(event.currentTarget);
        };

        const handleClose = () => {
            setAnchorEl(null);
        };

        return (
            <>
                <IconButton
                    aria-label="more"
                    id={`long-button-${paramsRow.id}`}
                    aria-controls={open ? 'long-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                >
                    <MoreVert />
                </IconButton>
                <Menu
                    id={`long-menu-${paramsRow.id}`}
                    MenuListProps={{
                        'aria-labelledby': `long-button-${paramsRow.id}`,
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >
                    <MenuItem onClick={() => handleOpenEditDialog(paramsRow)}>Editar Datos del Grupo</MenuItem>
                    <MenuItem onClick={() => handleOpenStatusDialog(paramsRow)}>Editar Estado</MenuItem>
                    <MenuItem onClick={() => handleVerInscritos(paramsRow.id)}>Ver inscritos</MenuItem>
                </Menu>
            </>
        );
    };

    const token: any = Cookies.get("token");

    const columns: GridColDef[] = [
        {
            field: 'acciones', headerName: '', width: 50,
            renderCell: (params) => <RowMenu rowIndex={params.row} />,
        },
        { field: 'nombre', headerName: 'Nombre', width: 100 },
        { field: 'curso', headerName: 'Curso', width: 100 },
        {
            field: 'cupos', headerName: 'Cupos', width: 100, type: 'number', headerAlign: 'left',
            renderCell: (params: GridCellParams) => (
                <Chip
                    label={params.value as number}
                    sx={{
                        backgroundColor: "#4277c2", // Rojo para inactivo
                        color: "white", // Texto en blanco para mejor visibilidad
                        borderRadius: 1, // Bordes redondeados
                        width: "100%", // Ancho fijo
                        fontWeight: "bold", // Fuente en negrita
                        fontSize: "1rem", // Tamaño de fuente más pequeño
                    }} />),
        },
        {
            field: 'inscritos',
            headerName: 'Inscritos',
            width: 130,
            type: 'number',
            headerAlign: 'left',
            align: 'left',
            renderCell: (params: GridCellParams) => {
                const inscritos = params.value as any;
                return (
                    <>
                        <Chip
                            label={inscritos}
                            sx={{
                                color: "#292929",
                                borderRadius: 1,
                                width: "50%",
                                fontWeight: "bold",
                                fontSize: "1rem",
                                textAlign: "center",
                            }}
                        />
                        <IconButton
                            component={RouterLink}
                           // to={`/admin/grupos/${(params as any).id}/estudiantes`}
                            to={`/admin/estudiantes-curso-grupo`}
                            color="primary"
                            aria-label="ver estudiantes"
                        >
                            <People />
                        </IconButton>
                    </>
                );
            },
        },
        { field: 'dia', headerName: 'Dia', width: 80, type: 'string' },
        {
            field: 'horaInicio', headerName: 'Hora de inicio', width: 120, type: 'string',
            renderCell: (params: GridCellParams) => {
                return formatTime(params.value);
            }
        },
        {
            field: 'horaFin', headerName: 'Hora de cierre', width: 120, type: 'string',
            renderCell: (params: GridCellParams) => {
                return formatTime(params.value);
            }
        },
        {
            field: 'fechaInicio', headerName: 'Fecha Inicio', width: 110, type: 'date',
        },
        {
            field: 'fechaFin', headerName: 'Fecha Fin', width: 110, type: 'date',
        },
        {
            field: 'estado', headerName: 'Estado', headerAlign: "left", width: 120, type: 'string',
            renderCell: (params: GridCellParams) => (
                <Chip
                    label={params.value as string}
                    sx={{
                        backgroundColor: params.value === "activo" ? "#81C784" : // Verde para activo
                            params.value === "inactivo" ? "#C94A4A" : "grey", // Rojo para inactivo
                        color: "white", // Texto en blanco para mejor visibilidad
                        borderRadius: 1, // Bordes redondeados
                        width: "100%", // Ancho fijo
                        fontWeight: "bold", // Fuente en negrita
                        fontSize: "1rem", // Tamaño de fuente más pequeño
                    }} />),
        },
    ];

    function formatTime(timeValue: any) {
        if (!timeValue) return '';
        const [hours, minutes] = timeValue.split(':');
        const hour = parseInt(hours, 10);
        const suffix = hour >= 12 ? 'PM' : 'AM';
        const displayHour = hour % 12 || 12;
        return `${displayHour}:${minutes} ${suffix}`;
    }

    const [grupos, setGrupos] = useState<any>([]);
    const [cursos, setCursos] = useState<any>([]);
    const [loading, setLoading] = useState<any>(true);
    const [error, setError] = useState<any>(null);

    useEffect(() => {
        const fetchGrupos = async () => {
            setLoading(true);
            const response = await getGruposAdmin(token);
            if (!response.ok) {
                setError('No se pudo cargar los grupos');
                setGrupos([]);
            } else {
                console.log(response.grupos.grupos);

                const gruposTransformados = response.grupos.grupos.map((grupo: any) => ({
                    ...grupo,
                    curso: grupo.curso.nombre,
                    fechaInicio: new Date(grupo.fechaInicio.split("Z")[0]),
                    fechaFin: new Date(grupo.fechaFin.split("Z")[0]),
                    inscritos: grupo._count.inscripciones,
                }));
                setGrupos(gruposTransformados);
            }
            setLoading(false);
        };
        fetchGrupos();
    }, []);

    useEffect(() => {
        const fetchCursos = async () => {
            setLoading(true);
            const response = await getCursosAdmin(token);
            if (!response.ok) {
                setError('No se pudo cargar los cursos');
                setGrupos([]);
            } else {
                setCursos(response.cursos.cursos);
            }
            setLoading(false);
        };
        fetchCursos();
    }, []);

    const rows: GridRowsProp = grupos;
    const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
        items: [],
        quickFilterExcludeHiddenColumns: true,
        quickFilterValues: [''],
    });

    const [columnVisibilityModel, setColumnVisibilityModel] =
        React.useState<GridColumnVisibilityModel>({});



    const formatDateForDisplay = (date: Date) => {
        if (!date) return '';
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    function formatDateToISO(dateStr: any) {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const {
        register: registerAdd,
        handleSubmit: handleSubmitAdd,
        formState: { errors: errorsAdd },
        reset: resetAdd,
        getValues: getValuesAdd
    } = useForm({
        defaultValues: {
            nombre: '',
            cupos: '',
            dia: '',
            horaInicio: '',
            horaFin: '',
            fechaInicio: '',
            fechaFin: '',
            estado: '',
            cursoId: '',
        }
    });

    const {
        register: registerEdit,
        handleSubmit: handleSubmitEdit,
        formState: { errors: errorsEdit },
        reset: resetEdit,
        getValues: getValuesEdit,
        setValue: setValueEdit
    } = useForm();

    const {
        handleSubmit: handleSubmitStatus,
        reset: resetStatus,
    } = useForm();

    const [openAddDialog, setOpenAddDialog] = useState(false);
    const [openEditDialog, setOpenEditDialog] = useState(false);
    const [openStatusDialog, setOpenStatusDialog] = useState(false);
    const [editData, setEditData] = useState({});
    const [statusData, setStatusData] = useState({});

    const handleOpenAddDialog = () => {
        setOpenAddDialog(true);
    };

    const handleCloseAddDialog = () => {
        setOpenAddDialog(false);
        resetAdd();
    };

    const handleVerInscritos = (id: any) => {
        navigate(`/admin/grupos/${id}/estudiantes`);
    }

    const handleOpenEditDialog = (row: any) => {
        const formattedRow = {
            ...row,
            fechaInicio: formatDateForDisplay(new Date(row.fechaInicio)),
            fechaFin: formatDateForDisplay(new Date(row.fechaFin)),
        };
        setEditData(formattedRow);
        resetEdit(formattedRow);
        setOpenEditDialog(true);
    };

    const handleCloseEditDialog = () => {
        setOpenEditDialog(false);
    };

    const handleOpenStatusDialog = (row: any) => {
        setStatusData(row);
        resetStatus({ estado: row.estado });
        setOpenStatusDialog(true);
    };

    const handleCloseStatusDialog = () => {
        setOpenStatusDialog(false);
    };

    const handleSaveAdd = handleSubmitAdd(async (data) => {

        setLoading(true);
        await postGrupo(token, data);
        const response = await getGruposAdmin(token);
        if (!response.ok) {
            setError('No se pudo cargar los cursos');
            setGrupos([]);
        } else {
            const gruposTransformados = response.grupos.grupos.map((grupo: any) => ({
                ...grupo,
                curso: grupo.curso.nombre,
                fechaInicio: new Date(grupo.fechaInicio.split("Z")[0]),
                fechaFin: new Date(grupo.fechaFin.split("Z")[0]),
                inscritos: grupo._count.inscripciones,
            }));
            setGrupos(gruposTransformados);
        }
        setLoading(false);
        handleCloseAddDialog();
    });

    const handleSaveEdit = handleSubmitEdit(async (data) => {

        setLoading(true);
        await putGrupo(token, data);
        const response = await getGruposAdmin(token);
        if (!response.ok) {
            setError('No se pudo cargar los cursos');
            setGrupos([]);
        } else {
            console.log(response.grupos.grupos);

            const gruposTransformados = response.grupos.grupos.map((grupo: any) => ({
                ...grupo,
                curso: grupo.curso.nombre,
                fechaInicio: new Date(grupo.fechaInicio.split("Z")[0]),
                fechaFin: new Date(grupo.fechaFin.split("Z")[0]),
                inscritos: grupo._count.inscripciones,
            }));
            setGrupos(gruposTransformados);
        }
        setLoading(false);
        handleCloseEditDialog();
    });

    const handleSaveStatus = handleSubmitStatus(async (data) => {
        setLoading(true);
        console.log(statusData);
        await putGrupo(token, { id: statusData.id, estado: statusData.estado });
        const response = await getGruposAdmin(token);
        if (!response.ok) {
            setError('No se pudo cargar los cursos');
            setGrupos([]);
        } else {
            const gruposTransformados = response.grupos.grupos.map((grupo: any) => ({
                ...grupo,
                curso: grupo.curso.nombre,
                fechaInicio: new Date(grupo.fechaInicio.split("Z")[0]),
                fechaFin: new Date(grupo.fechaFin.split("Z")[0]),
                inscritos: grupo._count.inscripciones,
            }));
            setGrupos(gruposTransformados);
        }
        setLoading(false);
        handleCloseStatusDialog();
    });

    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteId, setDeleteId] = useState(null);

    const handleOpenDeleteDialog = (id: any) => {
        setDeleteId(id);
        setOpenDeleteDialog(true);
    };

    const handleCloseDeleteDialog = () => {
        setOpenDeleteDialog(false);
    };

    const handleDelete = async (id: any) => {
        setLoading(true);
        await deleteGrupo(token, id);
        const response = await getGruposAdmin(token);
        if (!response.ok) {
            setError('No se pudo cargar los cursos');
            setGrupos([]);
        } else {
            const gruposTransformados = response.grupos.grupos.map((grupo: any) => ({
                ...grupo,
                curso: grupo.curso.nombre,
                fechaInicio: new Date(grupo.fechaInicio.toISOString().split("Z")[0]),
                fechaFin: new Date(grupo.fechaFin.toISOString().split("Z")[0]),
                inscritos: grupo._count.inscripciones,
            }));
            setGrupos(gruposTransformados);
        }
        setLoading(false);
        handleCloseDeleteDialog();
    };

    return (
        <AdminLayout title='Cursos'>

            < >


                {loading ? <LoadingScreen /> :
                    error ? <div>Error: {error}</div>
                        : <Paper 
                            sx={{ overflow: "hidden", width: "100%", borderRadius: 2, mt: 0, p: 2 }}
                        >
                            <Grid item xs={12} container alignItems="center" justifyContent="space-between" mb={1}>

                                <Box>
                                    <Typography
                                        fontSize={22} component="div" align="left"   >
                                        Todos los Grupos
                                    </Typography>
                                </Box>

                                <Button onClick={handleOpenAddDialog} variant="contained" color="primary">
                                    Agregar nuevo grupo
                                </Button>


                            </Grid>

                            <Box sx={{ height: '85vh' }}>
                                <DataGrid
                                    columns={columns}
                                    rows={rows}
                                    sx={{ padding: "10px" }}
                                    slots={{ toolbar: GridToolbar }}
                                    filterModel={filterModel}
                                    isRowSelectable={() => false}
                                    onFilterModelChange={(newModel) => setFilterModel(newModel)}
                                    slotProps={{
                                        toolbar: {
                                            showQuickFilter: true,

                                        },
                                    }}
                                    columnVisibilityModel={columnVisibilityModel}
                                    onColumnVisibilityModelChange={(newModel) =>
                                        setColumnVisibilityModel(newModel)
                                    }
                                />
                            </Box>
                        </Paper>
                }


            </>

            {/* Dialog for Adding New Course */}
            <Dialog open={openAddDialog} onClose={handleCloseAddDialog}>
                <form onSubmit={handleSaveAdd}>
                    <DialogTitle>Agregar Nuevo Grupo</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="nombre"
                            label="Nombre del Grupo"
                            fullWidth
                            variant="outlined"
                            {...registerAdd("nombre", {
                                required: "El nombre es requerido",
                                minLength: {
                                    value: 5,
                                    message: "El nombre debe tener al menos 5 caracteres"
                                }
                            })}
                            error={Boolean(errorsAdd.nombre)}
                            helperText={errorsAdd.nombre?.message}
                        />
                        <TextField
                            margin="dense"
                            id="cupos"
                            label="Cupos"
                            type="number"
                            fullWidth
                            variant="outlined"
                            {...registerAdd("cupos", {
                                required: "La cantidad de cupos es requerida",
                                validate: value => +value > 0 || "Debe ser mayor que 0"
                            })}
                            error={Boolean(errorsAdd.cupos)}
                            helperText={errorsAdd.cupos?.message}
                        />
                        <TextField
                            select
                            label="Día"
                            fullWidth
                            margin="dense"
                            id="dia"
                            variant="outlined"
                            {...registerAdd("dia", {
                                required: "El día es requerido",
                                validate: value => ['Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado', 'Domingo'].includes(value) || "Debe ser un día válido"
                            })}
                            error={Boolean(errorsAdd.dia)}
                            helperText={errorsAdd.dia?.message}
                        >

                            <MenuItem value="Lunes">Lunes</MenuItem>
                            <MenuItem value="Martes">Martes</MenuItem>
                            <MenuItem value="Miercoles">Miércoles</MenuItem>
                            <MenuItem value="Jueves">Jueves</MenuItem>
                            <MenuItem value="Viernes">Viernes</MenuItem>
                            <MenuItem value="Sabado">Sábado</MenuItem>
                            <MenuItem value="Domingo">Domingo</MenuItem>
                        </TextField>

                        <TextField
                            margin="dense"
                            id="horaInicio"
                            label="Hora de Inicio"
                            type="time"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            {...registerAdd("horaInicio", {
                                required: "La hora de inicio es requerida",
                                pattern: {
                                    value: /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/,
                                    message: "Formato de hora incorrecto (debe ser HH:MM)"
                                },
                                validate: value => value !== '00:00' || "La hora de inicio no puede ser 00:00"
                            })}
                            error={Boolean(errorsAdd.horaInicio)}
                            helperText={errorsAdd.horaInicio?.message}
                        />
                        <TextField
                            margin="dense"
                            id="horaFin"
                            label="Hora de Fin"
                            type="time"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            {...registerAdd("horaFin", {
                                required: "La hora de fin es requerida",
                                pattern: {
                                    value: /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/,
                                    message: "Formato de hora incorrecto (debe ser HH:MM)"
                                }
                            })}
                            error={Boolean(errorsAdd.horaFin)}
                            helperText={errorsAdd.horaFin?.message}
                        />

                        <TextField
                            margin="dense"
                            id="fechaInicio"
                            label="Fecha de Inicio"
                            type="date"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            {...registerAdd("fechaInicio", {
                                required: "La fecha de inicio es requerida",
                                validate: value => new Date(value) > new Date() || "La fecha de inicio debe ser futura"
                            })}
                            error={Boolean(errorsAdd.fechaInicio)}
                            helperText={errorsAdd.fechaInicio?.message}
                        />
                        <TextField
                            margin="dense"
                            id="fechaFin"
                            label="Fecha de Fin"
                            type="date"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            {...registerAdd("fechaFin", {
                                required: "La fecha de fin es requerida",
                                validate: {
                                    futureDate: value => new Date(value) > new Date() || "La fecha de fin debe ser futura",
                                    afterStartDate: value => {
                                        const startDate = getValuesAdd("fechaInicio");
                                        return startDate && new Date(value) > new Date(startDate) || "La fecha de fin debe ser mayor que la fecha de inicio";
                                    }
                                }
                            })}
                            error={Boolean(errorsAdd.fechaFin)}
                            helperText={errorsAdd.fechaFin?.message}
                        />



                        <TextField
                            select
                            label="Curso"
                            fullWidth
                            margin="dense"
                            variant="outlined"
                            {...registerAdd("cursoId", {
                                required: "Debe seleccionar un curso",
                                validate: value => +value > 0 || "Debe ser mayor que 0"
                            })}
                            error={Boolean(errorsAdd.cursoId)}
                            helperText={errorsAdd.cursoId?.message}
                        >
                            {cursos.map((curso: any) => (
                                <MenuItem key={curso.id} value={curso.id}>
                                    {curso.nombre}
                                </MenuItem>
                            ))}
                        </TextField>
                    </DialogContent>
                    <DialogActions>

                        <Button onClick={handleCloseAddDialog} color="error">Cancelar</Button>
                        <Button type="submit" color="primary">  {loading ? <CircularProgress /> : "Guardar"}</Button>
                    </DialogActions>
                </form>
            </Dialog>

            {/* Dialog for Editing Existing Course */}
            <Dialog open={openEditDialog} onClose={handleCloseEditDialog}>
                <form onSubmit={handleSaveEdit}>
                    <DialogTitle>Editar Grupo</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="nombre"
                            label="Nombre del Grupo"
                            type="text"
                            fullWidth
                            {...registerEdit("nombre", {
                                required: "El nombre es requerido",
                                minLength: { value: 5, message: "El nombre debe tener al menos 5 caracteres" }
                            })}
                            error={Boolean(errorsEdit.nombre)}
                        />
                        <TextField
                            margin="dense"
                            id="cupos"
                            label="Cupos"
                            type="number"
                            fullWidth
                            {...registerEdit("cupos", {
                                required: "La cantidad de cupos es requerida",
                                validate: value => +value > 0 || "Debe ser mayor que 0"
                            })}
                            error={Boolean(errorsEdit.cupos)}
                        />
                        <TextField
                            select
                            label="Día"
                            fullWidth
                            margin="dense"
                            id="dia"
                            variant="outlined"
                            value={(editData as any).dia || ''}
                            onChange={e => {
                                const newDay = e.target.value;
                                setEditData(prev => ({ ...prev, dia: newDay }));
                                setValueEdit('dia', newDay, { shouldValidate: true });
                            }}
                            error={Boolean(errorsEdit.dia)}
                        >
                            <MenuItem value="Lunes">Lunes</MenuItem>
                            <MenuItem value="Martes">Martes</MenuItem>
                            <MenuItem value="Miercoles">Miércoles</MenuItem>
                            <MenuItem value="Jueves">Jueves</MenuItem>
                            <MenuItem value="Viernes">Viernes</MenuItem>
                            <MenuItem value="Sabado">Sábado</MenuItem>
                            <MenuItem value="Domingo">Domingo</MenuItem>
                        </TextField>
                        <TextField
                            margin="dense"
                            id="horaInicio"
                            label="Hora de Inicio"
                            type="time"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            {...registerEdit("horaInicio", {
                                required: "La hora de inicio es requerida",
                                pattern: {
                                    value: /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/,
                                    message: "Formato de hora incorrecto (debe ser HH:MM)"
                                },
                                validate: value => value !== '00:00' || "La hora de inicio no puede ser 00:00"
                            })}
                            error={Boolean(errorsEdit.horaInicio)}
                        />
                        <TextField
                            margin="dense"
                            id="horaFin"
                            label="Hora de Fin"
                            type="time"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            {...registerEdit("horaFin", {
                                required: "La hora de fin es requerida",
                                pattern: {
                                    value: /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/,
                                    message: "Formato de hora incorrecto (debe ser HH:MM)"
                                }
                            })}
                            error={Boolean(errorsEdit.horaFin)}
                        />
                        <TextField
                            margin="dense"
                            id="fechaInicio"
                            label="Fecha de Inicio"
                            type="date"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            {...registerEdit("fechaInicio", {
                                required: "La fecha de inicio es requerida",
                                validate: value => new Date(value) > new Date() || "La fecha de inicio debe ser futura"
                            })}
                            error={Boolean(errorsEdit.fechaInicio)}
                        />
                        <TextField
                            margin="dense"
                            id="fechaFin"
                            label="Fecha de Fin"
                            type="date"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            {...registerEdit("fechaFin", {
                                required: "La fecha de fin es requerida",
                                validate: {
                                    futureDate: value => new Date(value) > new Date() || "La fecha de fin debe ser futura",
                                    afterStartDate: value => {
                                        const startDate = getValuesEdit("fechaInicio");
                                        return startDate && new Date(value) > new Date(startDate) || "La fecha de fin debe ser mayor que la fecha de inicio";
                                    }
                                }
                            })}
                            error={Boolean(errorsEdit.fechaFin)}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseEditDialog} color="error">Cancelar</Button>
                        <Button type="submit" color="primary">{loading ? <CircularProgress /> : "Guardar"}</Button>
                    </DialogActions>
                </form>
            </Dialog>

            <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
                <DialogTitle>Confirmación</DialogTitle>
                <DialogContent>
                    <DialogContentText>¿Estás seguro de que quieres eliminar este grupo?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDeleteDialog}>No</Button>
                    <Button onClick={() => handleDelete(deleteId)} color="error" autoFocus>{loading ? <CircularProgress /> : "Sí"}</Button>
                </DialogActions>
            </Dialog>

            {/* Dialog for Editing Status */}
            <Dialog open={openStatusDialog} onClose={handleCloseStatusDialog}>
                <form onSubmit={handleSaveStatus}>
                    <DialogTitle>Editar Estado del Grupo</DialogTitle>
                    <DialogContent>
                        <TextField
                            select
                            label="Estado"
                            fullWidth
                            margin="dense"
                            id="estado"
                            variant="outlined"
                            value={(statusData as any).estado || ''}
                            onChange={(e) => {
                                const newEstado = e.target.value;
                                setStatusData(prev => ({ ...prev, estado: newEstado }));
                            }}
                        >
                            <MenuItem value="activo">Activo</MenuItem>
                            <MenuItem value="inactivo">Inactivo</MenuItem>
                            <MenuItem value="archivado">Archivado</MenuItem>
                            <MenuItem value="lleno">Lleno</MenuItem>
                        </TextField>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseStatusDialog} color="error">Cancelar</Button>
                        <Button type="submit" color="primary">{loading ? <CircularProgress /> : "Guardar"}</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </AdminLayout>
    )
}
